import React, { useEffect, useEffectEvent, useRef, useState } from 'react'

import { SubAccount } from '../../../api/services/dd_panel_sub_accounts/types.ts'
import { useDebounce } from '../../../hooks/useDebounce.ts'
import Input from '../../common/forms/Input/Input.tsx'

type SearchAccountProps = {
  allAccounts: SubAccount[] | null
  getFilteredAccounts: (email: string[] | null) => void
}

const SearchAccount = (props: SearchAccountProps) => {
  const { allAccounts, getFilteredAccounts } = props

  const inputRef = useRef<HTMLInputElement | null>(null)

  const [isFocused, setIsFocused] = useState(false)
  const [isTyping, setIsTyping] = useState(false)
  const [email, setEmail] = useState<string>('')

  const prevEmailRef = useRef<string>('')
  const skipNextBlurRestoreRef = useRef(false)

  const debounceSearch = useDebounce(email, 400)
  const subAccountsEmail = allAccounts?.map((acc) => acc.user_email) || []

  const searchEmail = useEffectEvent(() => {
    if (!isFocused || !isTyping) return

    const filtered =
      isTyping &&
      subAccountsEmail.filter((acc) => acc.includes(debounceSearch))

    if (filtered) {
      getFilteredAccounts(filtered)
    }
  })

  useEffect(() => {
    searchEmail()
  }, [debounceSearch, isFocused, isTyping])

  const finishInteraction = () => {
    setIsFocused(false)
    setIsTyping(false)
    inputRef.current?.blur()
  }

  return (
    <div className={'relative flex flex-col'}>
      <label className="mb-2 block font-medium text-gray-900 dark:text-white">
        Filtruj wg adresu email
      </label>
      <Input
        ref={inputRef}
        id="phrase"
        autoCapitalize="off"
        name="phrase"
        type="text"
        value={email}
        onFocus={() => {
          prevEmailRef.current = email || ''
          setEmail('')
          setIsFocused(true)
          setIsTyping(false)
          getFilteredAccounts(null)
        }}
        onBlur={() => {
          if (skipNextBlurRestoreRef.current) {
            skipNextBlurRestoreRef.current = false
            setIsFocused(false)
            setIsTyping(false)
            return
          }

          setIsFocused(false)
          setIsTyping(false)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            finishInteraction()
          }

          if (e.key === 'Enter') {
            e.preventDefault()
          }
        }}
        onChange={(e) => {
          setEmail(e.target.value)
          setIsTyping(true)
        }}
        className={'w-full mb-0'}
        inputClassName={'pl-2'}
      />
    </div>
  )
}

export default SearchAccount
